import "./themeFirstPage.css";
import back_blue from "./../../static/images/background_1.webp";
import back_yellow from "./../../static/images/fundo_amarelo.jpg";
export default function ThemeFirstPage({ children, color = 'blue' }){
    return(
    <div className="themeFirstPage" style={{ backgroundImage: `url(${color === 'blue'?back_blue:back_yellow})` }} >
        <div className="container ">
            <div className="content">
                {children}
            </div>
        </div>
    </div>)
}